import type { ProductStepId } from '../model/product-steps'

export function stepForFieldPath(path: string): ProductStepId {
  if (path === 'name') return 'basico'
  if (path.startsWith('pixels.')) return 'tracking'
  if (path.startsWith('orderBumps.') || path.startsWith('funnelNodes.')) return 'funnel'
  if (path.startsWith('coupons.')) return 'cupons'
  if (path.startsWith('coproducers.')) return 'coproducao'
  if (path === 'split') return 'preco'
  if (path.startsWith('emailTemplate.')) return 'email'
  return 'preco'
}

export function stepHasFieldError(
  stepId: ProductStepId,
  errors: Readonly<Record<string, string | undefined>>,
): boolean {
  return Object.keys(errors).some((path) => stepForFieldPath(path) === stepId)
}

export function firstStepWithError(
  errors: Readonly<Record<string, string | undefined>>,
): ProductStepId {
  const order: ProductStepId[] = [
    'basico',
    'preco',
    'funnel',
    'tracking',
    'cupons',
    'coproducao',
    'email',
  ]
  return order.find((step) => stepHasFieldError(step, errors)) ?? 'preco'
}
